// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import moment from 'moment'
import axios from 'axios'

//页面加载进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 简单配置
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })
// window.sessionStorage.setItem('token',false)

//导入element组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引入global.css全局样式控制文件
import './assets/css/global.css'
Vue.prototype.$http = axios

// 'YYYY-MM-DD HH:mm:ss'
Vue.prototype.moment = moment
Vue.filter('dateFormat', function (dateStr, pattern = 'YYYY-MM-DD') {
  return moment.utc(dateStr).format(pattern)
})
Vue.filter('dateFormatTime', function (dateStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment.utc(dateStr).format(pattern)
})

import { getItem, setItem, clear, keys, removeItem } from './utils/storage'
Vue.prototype.getItem = getItem
Vue.prototype.setItem = setItem
Vue.prototype.clear = clear
Vue.prototype.keys = keys
Vue.prototype.removeItem = removeItem

Vue.config.productionTip = false

Vue.use(ElementUI);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js